import React from 'react';
import { useCart } from '../context/CartContext';

const CartSummary = ({ onCheckout, onRemoveItem }) => {
  const { items, total } = useCart();

  if (items.length === 0) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t border-gray-200 p-4 md:p-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="flex-1">
            <h3 className="font-semibold text-lg mb-2">Cart ({items.length} items)</h3>
            <div className="flex flex-wrap gap-2">
              {items.map((item) => (
                <div 
                  key={item.cartItemId} 
                  className="bg-gray-100 px-3 py-1 rounded-full text-sm flex items-center gap-2"
                >
                  <span>{item.name}</span>
                  <button
                    onClick={() => onRemoveItem(item.cartItemId, item.id)}
                    className="text-red-500 hover:text-red-700"
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
          </div>
          <div className="flex items-center gap-4">
            <div className="text-right">
              <p className="text-sm text-gray-600">Total</p>
              <p className="text-2xl font-bold text-primary">€{total}</p>
            </div>
            <button
              onClick={onCheckout}
              className="bg-primary text-white px-6 py-3 rounded-md hover:bg-primary-dark transition-colors whitespace-nowrap"
            >
              Make it Happen
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartSummary;
